export const CachedFilled = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M19 8.5L15 12.5H18C18 15.81 15.31 18.5 12 18.5C10.99 18.5 10.03 18.25 9.2 17.8L7.74 19.26C8.97 20.04 10.43 20.5 12 20.5C16.42 20.5 20 16.92 20 12.5H23L19 8.5ZM6 12.5C6 9.19 8.69 6.5 12 6.5C13.01 6.5 13.97 6.75 14.8 7.2L16.26 5.74C15.03 4.96 13.57 4.5 12 4.5C7.58 4.5 4 8.08 4 12.5H1L5 16.5L9 12.5H6Z"
        fill="#00C0F3"
      />
    </svg>
  );
};